import { alternateArmyNames } from '../../../list/alternativeNames.js';
export const reversedNames = (() => {
    const map = new Map();
    alternateArmyNames.forEach((aliases, fullName) => {
        aliases.forEach((alias) => {
            map.set(alias.toLowerCase(), fullName.toLowerCase());
        });
    });
    return map;
})();
export const ArmyFilter = {
    name: 'Army',
    keys: ['a', 'army'],
    description: 'Filter by army name',
    examples: ['army:cities'],
    exec: (node, dataset) => {
        if (node.type === 'pair') {
            const armyNameMatches = (s) => {
                if (node.isRegex) {
                    const regex = new RegExp(node.value);
                    return regex.test(s.armyName);
                }
                const lc_value = node.value.toLowerCase();
                const full_name = reversedNames.get(lc_value);
                return s.armyName.toLowerCase().includes(full_name ?? lc_value);
            };
            if (node.negated) {
                return dataset.filter((s) => !armyNameMatches(s));
            }
            return dataset.filter((s) => armyNameMatches(s));
        }
        return dataset;
    },
};
